import {
    generateReportConfigurationExcludedRecordsWorkbook,
    generateReportConfigurationWorkbook,
    getReportConfigurationConfigVersion,
    getReportConfigurationConfigVersions,
    saveReportConfigurationConfig,
    updateReportConfigurationConfig,
} from "../../../../service/httpsCalls";
import type {
    ReportConfigurationConfigVersionDetailDto,
    ReportConfigurationConfigVersionSummaryDto,
    SaveReportConfigurationConfigResultDto,
} from "../types";

export const loadConfigVersions = (reportId: number, signal?: AbortSignal) =>
    getReportConfigurationConfigVersions(reportId, signal) as Promise<ReportConfigurationConfigVersionSummaryDto[]>;

export const loadConfigVersion = (configVersionId: number, signal?: AbortSignal) =>
    getReportConfigurationConfigVersion(configVersionId, signal) as Promise<ReportConfigurationConfigVersionDetailDto>;

export const saveConfig = (payload: unknown) =>
    saveReportConfigurationConfig(payload) as Promise<SaveReportConfigurationConfigResultDto>;

export const updateConfig = (configVersionId: number, payload: unknown) =>
    updateReportConfigurationConfig(configVersionId, payload) as Promise<SaveReportConfigurationConfigResultDto>;

export const generateWorkbook = (reportId: number, configVersionId?: number | null) =>
    generateReportConfigurationWorkbook(reportId, configVersionId);

export const generateExcludedRecordsWorkbook = (reportId: number, configVersionId?: number | null, onDownloadProgress?: (loadedBytes: number) => void) =>
    generateReportConfigurationExcludedRecordsWorkbook(reportId, configVersionId, onDownloadProgress);
